import * as React from 'react';
import { Component } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

class Content extends Component {
    constructor() {
        super();
        this.state = {
            show: false
        };
    }

    render() {
        return (
            <div className={`${this.props.show ? 'd-block' : 'd-none'}`}>
                <Container className='site-map px-0'>
                    <Row>
                        <Col xs={10} className='ml-auto mr-auto content'>
                            <div className="hero-callout">
                                <h1 className="title">
                                    Site Map
                                </h1>
                            </div>
                            
                            <div className='link-section'>
                                <h3 className='title'>About Us</h3>
                                <a href='/about-us' data-analytics-parent-category='About Us'>
                                    We Are All In This Together
                                </a>
                                <a
                                    href='/community-involvement/community-commitments'
                                    data-analytics-parent-category='About Us'
                                >
                                    Community Commitments
                                </a>
                            </div>

                            <div className='link-section'>
                                <h3 className='title'>HIV Landscape</h3>
                                <a
                                    href='/landscape/history-of-hiv/'
                                    data-analytics-parent-category='HIV Landscape'
                                >
                                    History of the HIV Epidemic
                                </a>
                                <a
                                    href='/landscape/state-of-epidemic/'
                                    data-analytics-parent-category='HIV Landscape'
                                >
                                    State of the HIV Epidemic
                                </a>
                                <a
                                    href='/landscape/ehe/'
                                    data-analytics-parent-category='HIV Landscape'
                                >
                                    Plans for Ending the HIV Epidemic
                                </a>
                                <a
                                    href='/landscape/hiv-care-continuum/'
                                    data-analytics-parent-category='HIV Landscape'
                                >
                                    HIV Care Continuum
                                </a>
                                <a
                                    href='/landscape/hiv-testing/'
                                    data-analytics-parent-category='HIV Landscape'
                                >
                                    HIV Testing
                                </a>
                                <a
                                    href='/landscape/hiv-rapid-start/'
                                    data-analytics-parent-category='HIV Landscape'
                                >
                                    Rapid Start Initiation
                                </a>
                            </div>

                            <div className='link-section'>
                                <h3 className='title'>Community Involvement</h3>
                                <a
                                    href='/community-involvement/community-commitments'
                                    data-analytics-parent-category='Community Involvement'
                                >
                                    Community Commitments
                                </a>
                                <a
                                    href='/championsofchange'
                                    data-analytics-parent-category='Celebrating Black Women Leaders'
                                >
                                    Champions of Change: Black Women Leaders
                                </a>
                                <a
                                    href='/community-involvement/voices-of-strength/'
                                    data-analytics-parent-category='Community Involvement'
                                >
                                    Voices of Strength
                                </a>
                                <a
                                    href='/community-involvement/social-toolkit/'
                                    data-analytics-parent-category='Community Involvement'
                                >
                                    Social Media Toolkit
                                </a>
                                <a
                                    href='/community-involvement/events/'
                                    data-analytics-parent-category='Community Involvement'
                                >
                                    Events
                                </a>
                            </div>

                            <div className='link-section'>
                                <h3 className='title'>Deeper Dive</h3>
                                <a
                                    href='/deeper-dive/content-index/'
                                    data-analytics-parent-category='Deeper Dive'
                                >
                                    Featured Articles
                                </a>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}

export default Content;
